module.exports = __webpack_public_path__ + "static/no-chat-5e049022a4bc1b01f70489d74b031967.png";